// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"7f02c563","787":"77f02c58"}[chunkId] + ".chunk.js";
};